import React, { useEffect, useState, useRef } from "react";
import { NodeApi, Tree } from "react-arborist";
import styles from "../../../../forms/styles/tree.module.css";
import { Data, OfficialMonitorTreeProps } from "./types";
import Node from "./TreeNode";
import { INDENT_STEP } from "./constants";
import { ContextMenu, ContextMenuContent, ContextMenuItem, ContextMenuTrigger } from "@/components/ui/context-menu";
import { DialogAction } from "@/components/form-builder/form-components/DialogAction";
import { useTree } from "./useTree";
import { useTranslations } from "use-intl";
import AddRegistratureDialog from "./AddRegistratureDialog";
import { Card } from "@/components/ui/card";
type OfficialMonitorWrapperProps = OfficialMonitorTreeProps & {
  officialMonGroups: Data[];
  institutionId: string;
  viewOnly?: boolean;
  refetchGroups: () => void;
};
function OfficialMonitorTree({
  officialMonGroups,
  viewOnly = false,
  ...props
}: OfficialMonitorWrapperProps) {
  const t = useTranslations();
  const [selectedFolderToDelete, setSelectedFolderToDelete] = useState<NodeApi<Data> | null>(null);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [isAddRegistratureDialogOpen, setIsAddRegistratureDialogOpen] = useState<boolean>(false);
  const {
    data,
    treeRef,
    onRename,
    onDelete,
    onCreateRootGroup,
    handleAddGroupInsideNode,
    onDeleteFolder,
    handleAddRegistratureInsideNode
  } = useTree(officialMonGroups, props.refetchGroups, props.institutionId);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0
  });
  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.clientWidth,
          height: containerRef.current.clientHeight
        });
      }
    };
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  return <div className="h-[calc(100vh-700px)] w-full overflow-auto" ref={containerRef} data-sentry-component="OfficialMonitorTree" data-sentry-source-file="OfficialMonitorTree.tsx">
      <AddRegistratureDialog isOpen={isAddRegistratureDialogOpen} onClose={() => setIsAddRegistratureDialogOpen(false)} onAdd={registratureId => {
      if (treeRef.current && selectedId) {
        handleAddRegistratureInsideNode(treeRef.current.get(selectedId)!, registratureId);
      }
      setIsAddRegistratureDialogOpen(false);
    }} institutionId={props.institutionId} data-sentry-element="AddRegistratureDialog" data-sentry-source-file="OfficialMonitorTree.tsx" />

      <DialogAction open={!!selectedFolderToDelete} onOpenChange={open => setSelectedFolderToDelete(open ? selectedFolderToDelete : null)} acceptText={t("sterge")} acceptCallback={async () => {
      if (selectedFolderToDelete) {
        await onDeleteFolder(selectedFolderToDelete);
        setSelectedFolderToDelete(null);
      }
    }} title={t("confirmaStergereaGrupului")} description={t("stergereaGrupuluiEsteIreversibilaSigurDorestiSaContinui")} data-sentry-element="DialogAction" data-sentry-source-file="OfficialMonitorTree.tsx" />

      <ContextMenu data-sentry-element="ContextMenu" data-sentry-source-file="OfficialMonitorTree.tsx">
        <ContextMenuTrigger disabled={viewOnly} data-sentry-element="ContextMenuTrigger" data-sentry-source-file="OfficialMonitorTree.tsx">
          <Card style={{
          height: dimensions.height,
          width: dimensions.width
        }} data-sentry-element="Card" data-sentry-source-file="OfficialMonitorTree.tsx">
            <Tree ref={treeRef} data={data} onRename={onRename} onDelete={onDelete} className={styles.tree} rowClassName={styles.row} onToggle={setSelectedId} padding={15} rowHeight={30} indent={INDENT_STEP} openByDefault={false} height={dimensions.height} width={dimensions.width} disableDrag={() => false} disableDrop={false} data-sentry-element="Tree" data-sentry-source-file="OfficialMonitorTree.tsx">
              {Node({
              handleAddGroupInsideNode,
              viewOnly,
              openRegistratureAddDialog: () => setIsAddRegistratureDialogOpen(true),
              onRemoveFolder: node => setSelectedFolderToDelete(node),
              treeRef: containerRef
            })}
            </Tree>
          </Card>
        </ContextMenuTrigger>
        <ContextMenuContent data-sentry-element="ContextMenuContent" data-sentry-source-file="OfficialMonitorTree.tsx">
          <ContextMenuItem onClick={() => onCreateRootGroup()} data-sentry-element="ContextMenuItem" data-sentry-source-file="OfficialMonitorTree.tsx">
            {t("src_app_dashboard_admin_institutions_id_official_monitor_components_OfficialMonitorTree_tsx_0")}
          </ContextMenuItem>
        </ContextMenuContent>
      </ContextMenu>
    </div>;
}
export default OfficialMonitorTree;